import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import { veevaIqviaProjects } from '../data/veevaProjects';
import ProjectDetailModal from './ProjectDetailModal';
import { FaArrowLeft } from 'react-icons/fa';

const VeevaProjectsPage = () => {
    const [selectedProject, setSelectedProject] = useState(null);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [pageAyudas, setPageAyudas] = useState(0);
    const [pageEmails, setPageEmails] = useState(0);

    const ITEMS_PER_PAGE_AYUDAS = 8;
    const ITEMS_PER_PAGE_EMAILS = 6;

    const ayudasVisuales = veevaIqviaProjects.ayudasVisuales;
    const approvedEmails = veevaIqviaProjects.approvedEmails;

    // Paginación para Ayudas Visuales
    const totalPagesAyudas = Math.ceil(ayudasVisuales.length / ITEMS_PER_PAGE_AYUDAS);
    const paginatedAyudas = ayudasVisuales.slice(
        pageAyudas * ITEMS_PER_PAGE_AYUDAS,
        (pageAyudas + 1) * ITEMS_PER_PAGE_AYUDAS
    );

    // Paginación para Approved Emails
    const totalPagesEmails = Math.ceil(approvedEmails.length / ITEMS_PER_PAGE_EMAILS);
    const paginatedEmails = approvedEmails.slice(
        pageEmails * ITEMS_PER_PAGE_EMAILS,
        (pageEmails + 1) * ITEMS_PER_PAGE_EMAILS
    );

    const handleProjectClick = (project) => {
        setSelectedProject(project);
        setShowDetailModal(true);
    };

    const handleCloseDetailModal = () => {
        setShowDetailModal(false);
        setSelectedProject(null);
    };

    return (
        <div className="bg-site bg-contain min-h-screen pt-2 lg:pt-4 pb-8">
            <div className="container mx-auto px-4">
                {/* Back Button */}
                <Link to="/" className="inline-block mb-8 mt-6">
                    <div className="flex items-center gap-2 bg-mainBlue text-white rounded-full px-4 py-2 hover:bg-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl">
                        <FaArrowLeft className="text-lg" />
                        <span className="font-semibold">Volver</span>
                    </div>
                </Link>

                {/* Header */}
                <motion.div
                    variants={fadeIn('up', 0.3)}
                    initial="hidden"
                    whileInView="show"
                    className="bg-white rounded-3xl shadow-2xl overflow-hidden p-6 lg:p-10 mb-8"
                >
                    <h1 className="text-mainYellow text-3xl lg:text-4xl font-bold mb-4">
                        Nuestro mundo Veeva y IQVIA
                    </h1>
                    <p className="text-mainBlue text-lg">
                        Explora nuestra galería de ayudas visuales y emails aprobados
                    </p>
                </motion.div>

                {/* Content */}
                <div className="space-y-12">
                    {/* Ayudas Visuales Section */}
                    {ayudasVisuales.length > 0 && (
                        <motion.div
                            variants={fadeIn('up', 0.3)}
                            initial="hidden"
                            whileInView="show"
                            className="bg-white rounded-3xl shadow-2xl overflow-hidden p-6 lg:p-10"
                        >
                            <h2 className="text-secondBlue text-2xl lg:text-3xl font-bold mb-8">
                                Ayudas Visuales
                            </h2>
                            <div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-6">
                                {paginatedAyudas.map((project) => (
                                    <motion.div
                                        key={project.id}
                                        variants={fadeIn('up', 0.2)}
                                        initial="hidden"
                                        whileInView="show"
                                        onClick={() => handleProjectClick(project)}
                                        className="group relative overflow-hidden rounded-lg cursor-pointer"
                                    >
                                        <div className="aspect-video overflow-hidden rounded-lg bg-gray-200">
                                            {project.thumbnail ? (
                                                <>
                                                    <img
                                                        src={project.thumbnail}
                                                        alt={project.name}
                                                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                                                    />
                                                    <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-colors duration-300" />
                                                </>
                                            ) : (
                                                <div className="w-full h-full flex items-center justify-center text-gray-400">
                                                    <span>Sin imagen</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black to-transparent text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            <p className="text-sm font-semibold truncate">{project.name}</p>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>

                            {/* Mobile Horizontal Scroll */}
                            <div className="sm:hidden overflow-x-auto pb-2 mb-6">
                                <div className="flex gap-6 min-w-min px-4">
                                    {paginatedAyudas.map((project) => (
                                        <motion.div
                                            key={project.id}
                                            variants={fadeIn('up', 0.2)}
                                            initial="hidden"
                                            whileInView="show"
                                            onClick={() => handleProjectClick(project)}
                                            className="group relative overflow-hidden rounded-lg cursor-pointer flex-shrink-0 w-64"
                                        >
                                            <div className="aspect-video overflow-hidden rounded-lg bg-gray-200">
                                                {project.thumbnail ? (
                                                    <>
                                                        <img
                                                            src={project.thumbnail}
                                                            alt={project.name}
                                                            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                                                        />
                                                        <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-colors duration-300" />
                                                    </>
                                                ) : (
                                                    <div className="w-full h-full flex items-center justify-center text-gray-400">
                                                        <span>Sin imagen</span>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black to-transparent text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                <p className="text-base font-semibold truncate">{project.name}</p>
                                            </div>
                                        </motion.div>
                                    ))}
                                </div>
                            </div>

                            {/* Pagination for Ayudas Visuales */}
                            {totalPagesAyudas > 1 && (
                                <div className="hidden sm:flex justify-end gap-2">
                                    {Array.from({ length: totalPagesAyudas }, (_, i) => (
                                        <button
                                            key={i}
                                            onClick={() => setPageAyudas(i)}
                                            className={`w-10 h-10 rounded-lg font-bold text-sm transition-all duration-300 ${
                                                pageAyudas === i
                                                    ? 'bg-mainYellow text-white shadow-lg'
                                                    : 'bg-gray-200 text-mainBlue hover:bg-gray-300'
                                            }`}
                                        >
                                            {i + 1}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </motion.div>
                    )}

                    {/* Approved emails Section */}
                    {approvedEmails.length > 0 && (
                        <motion.div
                            variants={fadeIn('up', 0.3)}
                            initial="hidden"
                            whileInView="show"
                            className="bg-white rounded-3xl shadow-2xl overflow-hidden p-6 lg:p-10"
                        >
                            <h2 className="text-secondBlue text-2xl lg:text-3xl font-bold mb-8">
                                Approved emails
                            </h2>
                            <div className="hidden sm:grid sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 mb-6">
                                {paginatedEmails.map((project) => (
                                    <motion.div
                                        key={project.id}
                                        variants={fadeIn('up', 0.2)}
                                        initial="hidden"
                                        whileInView="show"
                                        onClick={() => handleProjectClick(project)}
                                        className="group relative overflow-hidden rounded-lg cursor-pointer shadow-md hover:shadow-lg transition-shadow duration-300"
                                    >
                                        <div className="overflow-hidden rounded-lg bg-gray-200 aspect-[155/286]">
                                            {project.thumbnail ? (
                                                <>
                                                    <img
                                                        src={project.thumbnail}
                                                        alt={project.name}
                                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                                    />
                                                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/60 transition-colors duration-300" />
                                                </>
                                            ) : (
                                                <div className="w-full h-full flex items-center justify-center text-gray-400 bg-gray-200">
                                                    <span className="text-xs">Sin imagen</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black to-transparent text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            <p className="text-xs font-semibold truncate">{project.name}</p>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>

                            {/* Mobile Horizontal Scroll */}
                            <div className="sm:hidden overflow-x-auto pb-2 mb-6">
                                <div className="flex gap-3 min-w-min px-1">
                                    {paginatedEmails.map((project) => (
                                        <motion.div
                                            key={project.id}
                                            variants={fadeIn('up', 0.2)}
                                            initial="hidden"
                                            whileInView="show"
                                            onClick={() => handleProjectClick(project)}
                                            className="group relative overflow-hidden rounded-lg cursor-pointer shadow-md hover:shadow-lg transition-shadow duration-300 flex-shrink-0 w-32"
                                        >
                                            <div className="overflow-hidden rounded-lg bg-gray-200 aspect-[155/286]">
                                                {project.thumbnail ? (
                                                    <>
                                                        <img
                                                            src={project.thumbnail}
                                                            alt={project.name}
                                                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                                        />
                                                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/60 transition-colors duration-300" />
                                                    </>
                                                ) : (
                                                    <div className="w-full h-full flex items-center justify-center text-gray-400 bg-gray-200">
                                                        <span className="text-xs">Sin imagen</span>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black to-transparent text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                <p className="text-xs font-semibold truncate">{project.name}</p>
                                            </div>
                                        </motion.div>
                                    ))}
                                </div>
                            </div>

                            {/* Pagination for Approved Emails */}
                            {totalPagesEmails > 1 && (
                                <div className="hidden sm:flex justify-end gap-2">
                                    {Array.from({ length: totalPagesEmails }, (_, i) => (
                                        <button
                                            key={i}
                                            onClick={() => setPageEmails(i)}
                                            className={`w-10 h-10 rounded-lg font-bold text-sm transition-all duration-300 ${
                                                pageEmails === i
                                                    ? 'bg-mainYellow text-white shadow-lg'
                                                    : 'bg-gray-200 text-mainBlue hover:bg-gray-300'
                                            }`}
                                        >
                                            {i + 1}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </motion.div>
                    )}
                </div>
            </div>

            {/* Detail Modal */}
            <ProjectDetailModal
                isOpen={showDetailModal}
                onClose={handleCloseDetailModal}
                project={selectedProject}
            />
        </div>
    );
};

export default VeevaProjectsPage;
